//PrisutstvuyushchieNaZasedaniiPravleniyaFederatsii
import React, { } from 'react';

export default function UserSelector(props) {
    const { object } = props;
    return (
        <div>
            <div>
                <span>{object.lastname + " "}</span>
                <span>{object.firstname + " "}</span>
                <span>{object.patronymic}</span>
            </div>
            <div>{object.email}</div>
        </div>
    );
}
